import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 41,
    height: 28,
    marginLeft: -8,
  },
  path: {
    fill: '#E7392F',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      width="41"
      height="28"
      viewBox="0 0 15 10"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className={classes.path}
        d="M14.1,3.5v3c0,1.9-1.5,3.5-3.5,3.5H2V8h2V6H0V4h4V2H2V0h8.7
        C12.6,0,14.2,1.6,14.1,3.5C14.1,3.5,14.1,3.5,14.1,3.5z
        M12.1,3.5c0-0.8-0.6-1.5-1.5-1.5H5.9V8h4.8c0.8,0,1.5-0.7,1.5-1.5L12.1,3.5z"
      />
    </svg>
  );
};

export default LogoIcon;
